/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import LoanOfficerSettingsRepository from 'repositories/loanOfficer/LoanOfficerSettingsRepository';

const initialState = {
  loading: false,
};

const loanOfficerSettingsSlice = createSlice({
  name: 'loanOfficerSettingsSlice',
  initialState,
  reducers: {
    requestProfileReviewStart(state) {
      state.loading = true;
    },
    requestProfileReviewSuccess(state) {
      state.loading = false;
    },
    requestProfileReviewFail(state) {
      state.loading = false;
    },
  },
});

export const { actions } = loanOfficerSettingsSlice;

export default loanOfficerSettingsSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const requestProfileReview = async () => {
    dispatch(actions.requestProfileReviewStart());
    try {
      await LoanOfficerSettingsRepository.requestProfileReview();
      dispatch(actions.requestProfileReviewSuccess());
      return Promise.resolve();
    } catch (_error) {
      dispatch(actions.requestProfileReviewFail());
      return Promise.reject();
    }
  };

  return {
    requestProfileReview,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/slices/loanOfficerSettingsSlice.js